import { Tooltip } from "antd";

export  const UserName= ( name ="" ,  length= 15) =>{
    let userName = '' ,  isTruncated = false;

    if (typeof name == 'string') {
        if (typeof length !== 'number' || length <= 0) {
            userName =  name.slice(0, 12); // If maxLength is not valid, return the original string
          }else {
            userName =  name.length > length ? name.slice(0, length) + '...' : name ;
            isTruncated = name.length > length;
          }
      }

      return (
        <Tooltip title={isTruncated ? name : ''}>
        <div className={`capitalize`}>
          {userName}
        </div>
      </Tooltip>
      )
  }
  